import { Job } from "Models/job";

export const getJobName = (job?: Pick<Job, "reference" | "sequence">) => {
  // eslint-disable-next-line prettier/prettier
  return `${job?.reference || ""}${job?.sequence ? `/${job?.sequence}` : ""}`;
};
